// extracted by mini-css-extract-plugin
export default {"actionsCell":"ResultsTable-module__actionsCell__rHcdS","table":"ResultsTable-module__table__Bk1cW","button":"ResultsTable-module__button__1Jbal"};